import React from "react";
import "./QuickSelect.css";

const QuickSelect = ({answer, onClick}) => {
  return (
    <button className="quick-select-btn" onClick={() => onClick(answer)}>{answer}</button>
  );
};

export default QuickSelect;